module.exports = __webpack_public_path__ + "img/logo_shachihata.bb005e45.png";